import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import {on, Options} from "../utils/decorators";


@Options({
    template: false,
    ui: {
        scrollToBtn:  "[data-js-ui=btn-scroll]"
    }
})
export default class ScrollToView extends Marionette.View<Backbone.Model>{

    $body:any;

    onRender() {
        this.$body = $("html, body");
    }

    @on("click @ui.scrollToBtn")
    onScrollToBtnClick(event) {
        event.preventDefault();
        const scrollSelector = "[data-js-ui=scroll-target]";
        const $scrollTarget = this.$el.closest(scrollSelector).next();

        if ($scrollTarget.length) {
            this.$body.animate({ scrollTop: $scrollTarget.offset().top }, 500);
        }
    }
}



// WEBPACK FOOTER //
// ./@modules/views/scroll-to-view.ts